export const IsValidIpAddress = (ipaddress: string) => {
  if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
    return true
  }
  return false
}  


export const MinStringLength = (name: string, minLength: number): boolean => {
  return name !== undefined && name !== "" && name.length >= minLength;
}

export const IsGreateThan = (value: number, minValue: number): boolean => {
  return value > minValue;
}

export const IsGreateEqual = (value: number, minValue: number): boolean => {
  return value >= minValue;
}